import { useAppSelector } from './useAppSelector';

export function useCurrentPageInfo() {
  const currentPageMatch = useAppSelector(state => state.page.pageMatch);

  return {
    currentPageMatch,
  };
}
